import React, { useState } from "react";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

const REASONS = [
    { value: "inappropriate_content", label: "Неподходящий контент" },
    { value: "spam", label: "Спам" },
    { value: "false_information", label: "Ложная информация" },
    { value: "copyright_violation", label: "Нарушение авторских прав" },
    { value: "other", label: "Другое" },
];

export default function ReportSpotModal({ entityType, entityId, onClose }) {
    const [reason, setReason] = useState(REASONS[0].value);
    const [comment, setComment] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [success, setSuccess] = useState(false);

    const submit = async (event) => {
        event.preventDefault();
        setLoading(true);
        setError("");
        try {
            if (comment.trim().length === 0) {
                setError("Описание не может быть пустым");

                return;
            }

            await axios.post(
                `${API_BASE_URL}/api/reports`,
                { entityType, entityId, reason, description: comment.trim() || undefined },
                { withCredentials: true },
            );
            setSuccess(true);
        } catch (e) {
            setError(e?.response?.data?.error || "Не удалось отправить жалобу.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-modal-backdrop" onClick={onClose}>
            <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
                <button type="button" className="entity-popup__close" onClick={onClose} aria-label="Закрыть">
                    ×
                </button>
                <h3>Пожаловаться</h3>
                {success ? (
                    <>
                        <p>Жалоба отправлена. Спасибо!</p>
                        <div className="auth-form">
                            <button type="button" className="toolbar-btn" onClick={onClose}>
                                Закрыть
                            </button>
                        </div>
                    </>
                ) : (
                    <>
                        <form onSubmit={submit} className="auth-form">
                            <select
                                className="ui-select"
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                disabled={loading}
                            >
                                {REASONS.map((r) => (
                                    <option key={r.value} value={r.value}>{r.label}</option>
                                ))}
                            </select>
                            <textarea
                                className="ui-textarea"
                                rows={4}
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                placeholder="Опишите проблему подробнее"
                                maxLength={1000}
                                disabled={loading}
                            />
                            {error && <p className="form-message">{error}</p>}
                            <div className="auth-form__actions">
                                <button type="submit" className="toolbar-btn" disabled={loading}>
                                    {loading ? "Отправка..." : "Отправить"}
                                </button>
                                <button type="button" className="btn-outline" onClick={onClose} disabled={loading}>
                                    Отмена
                                </button>
                            </div>
                        </form>
                    </>
                )}
            </div>
        </div>
    );
}
